// extracted by mini-css-extract-plugin
export default {"bulletedText":"TextBulleted_bulletedText__EiW94"};